import { jsx as _jsx } from "react/jsx-runtime";
import { MatchBreakpointsProvider } from "@pancakeswap/uikit";
import { ThemeProvider } from "styled-components";
export var UIKitProvider = function(param) {
    var theme = param.theme, children = param.children;
    return /*#__PURE__*/ _jsx(MatchBreakpointsProvider, {
        children: /*#__PURE__*/ _jsx(ThemeProvider, {
            theme: theme,
            children: children
        })
    });
};
